/** Image Resolutions */
export const IMAGE_SIZES = [
    { title: '1024x1024', value: '1024x1024' },
    { title: '1024x1792', value: '1024x1792' },
    { title: '1792x1024', value: '1792x1024' },
];
